/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserCouponUsedPageListRespVo
 */
export interface GetUserCouponUsedPageListRespVo {
    /**
     * No
     * @type {number}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    id?: number;
    /**
     * 用户的优惠券id
     * @type {number}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    userCouponId?: number;
    /**
     * 优惠券名称
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    couponName?: string;
    /**
     * 优惠券金额
     * @type {number}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    couponAmount?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    currencyCode?: string;
    /**
     * 发行类型 1 管理员发放，2 活动发放
     * @type {number}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    grantType?: number;
    /**
     * 发行类型描述
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    grantTypeDesc?: string;
    /**
     * 发行种类
     * @type {Array<number>}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    additionalServiceIds?: Array<number>;
    /**
     * 发行种类(说明)
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    additionalServiceIdsDesc?: string;
    /**
     * 有效期开始时间
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    beginTime?: string;
    /**
     * 有效期结束时间
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    endTime?: string;
    /**
     * 发放日期
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    grantDate?: string;
    /**
     * 使用时间
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    createTime?: string;
    /**
     * 使用时间描述
     * @type {string}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    useTimeDesc?: string;
    /**
     * 优惠券是否长期有效 0 不是 1 是
     * @type {number}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    longTerm?: number;
    /**
     * 使用状态 1待使用 2已使用 3已过期 4已退回；不可用看 enable
     * @type {number}
     * @memberof GetUserCouponUsedPageListRespVo
     */
    userCouponStatus?: number;
}

/**
 * Check if a given object implements the GetUserCouponUsedPageListRespVo interface.
 */
export function instanceOfGetUserCouponUsedPageListRespVo(value: object): value is GetUserCouponUsedPageListRespVo {
    return true;
}

export function GetUserCouponUsedPageListRespVoFromJSON(json: any): GetUserCouponUsedPageListRespVo {
    return GetUserCouponUsedPageListRespVoFromJSONTyped(json, false);
}

export function GetUserCouponUsedPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCouponUsedPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userCouponId': json['userCouponId'] == null ? undefined : json['userCouponId'],
        'couponName': json['couponName'] == null ? undefined : json['couponName'],
        'couponAmount': json['couponAmount'] == null ? undefined : json['couponAmount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'grantType': json['grantType'] == null ? undefined : json['grantType'],
        'grantTypeDesc': json['grantTypeDesc'] == null ? undefined : json['grantTypeDesc'],
        'additionalServiceIds': json['additionalServiceIds'] == null ? undefined : json['additionalServiceIds'],
        'additionalServiceIdsDesc': json['additionalServiceIdsDesc'] == null ? undefined : json['additionalServiceIdsDesc'],
        'beginTime': json['beginTime'] == null ? undefined : json['beginTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'grantDate': json['grantDate'] == null ? undefined : json['grantDate'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'useTimeDesc': json['useTimeDesc'] == null ? undefined : json['useTimeDesc'],
        'longTerm': json['longTerm'] == null ? undefined : json['longTerm'],
        'userCouponStatus': json['userCouponStatus'] == null ? undefined : json['userCouponStatus'],
    };
}

export function GetUserCouponUsedPageListRespVoToJSON(json: any): GetUserCouponUsedPageListRespVo {
    return GetUserCouponUsedPageListRespVoToJSONTyped(json, false);
}

export function GetUserCouponUsedPageListRespVoToJSONTyped(value?: GetUserCouponUsedPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userCouponId': value['userCouponId'],
        'couponName': value['couponName'],
        'couponAmount': value['couponAmount'],
        'currencyCode': value['currencyCode'],
        'grantType': value['grantType'],
        'grantTypeDesc': value['grantTypeDesc'],
        'additionalServiceIds': value['additionalServiceIds'],
        'additionalServiceIdsDesc': value['additionalServiceIdsDesc'],
        'beginTime': value['beginTime'],
        'endTime': value['endTime'],
        'grantDate': value['grantDate'],
        'createTime': value['createTime'],
        'useTimeDesc': value['useTimeDesc'],
        'longTerm': value['longTerm'],
        'userCouponStatus': value['userCouponStatus'],
    };
}

